<template>
<div>
   <SidebarVue ref="sidebar" />
  <NavgatorDk
    ref="navgator"
    :barraTitulo="' Relatório Mensal - Desk'"
    :titulo="'relatório'"
  />

  <div class="card-container">
    <div class="card filter-container">
      <div class="row g-2 p-2">
        <div
          class="card-title gy-4 d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <i class="bi bi-funnel fs-5 icon-text-form"></i>
            <span class="txt-title-form ms-2">Parâmetros do Relatório</span>
          </div>
          <!-- botão collapse em mobile -->
          <button
            class="btn btn-filtro d-inline-flex align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#biFilters"
            aria-expanded="true"
            aria-controls="biFilters"
            style="max-width: 40px"
          >
            <i class="bi bi-chevron-down"></i>
          </button>
        </div>
      </div>
      <div id="biFilters" class="collapse show">
        <div class="row g-2 p-2">
          <div class="col-12 col-md-4 col-lg-4">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="selectedRelatorio"
              >
                <option value="all">Todos</option>
                <option value="Venda Finalizada">Finalizado</option>
                <option value="Venda Perdida">Perdido</option>
              </select>
              <label><strong>Escolha o tipo de Relatório</strong></label>
            </div>
          </div>
          <div class="col-12 col-md-2 col-lg-2">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="selectedFilter"
                @change="filtarRelatorios()"
              >
                <option value="hoje">Hoje</option>
                <option value="ontem">Ontem</option>
                <option value="mes_atual">Mês Atual</option>
                <option value="mes_anterior">Mês Anterior</option>
                <option value="personalizado">Personalizado</option>
              </select>
              <label><strong>Referência</strong></label>
            </div>
          </div>
          <div class="col-12 col-md-1 col-lg-1">
            <div class="form-floating">
              <button
                class="btn round-btn"
                @click="relatorio_avaliacoes_finalizadas()"
              >
                <i class="bi bi-search" title="Pesquisar"></i>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-5 ">
            <div v-if="selectedFilter === 'personalizado'">
              <div class="form-floating txt-form-label input-group">
                <input
                  type="date"
                  class="form-control txt-form-input"
                  v-model="startDate"
                />
                <span class="input-group-text">até</span>
                <input
                  type="date"
                  class="form-control txt-form-input"
                  v-model="endDate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Filtro Lojas-->
    <div class="card filter-container">
      <div class="row g-2 p-2">
        <div
          class="card-title gy-4 d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <i class="bi bi-shop fs-5 icon-text-form"></i>
            <span class="txt-title-form ms-2">Lojas</span>
          </div>
          <button
            class="btn btn-filtro d-inline-flex align-items-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#biFilters"
            aria-expanded="true"
            aria-controls="biFilters"
            style="max-width: 40px"
          >
            <i class="bi bi-chevron-down"></i>
          </button>
        </div>
      </div>
      <div class="">
        <div class="select-all mb-3">
          <div class="col-12 col-md-1 col-lg-1">
            <input
              class="btn-check"
              type="checkbox"
              id="checkboxTodos"
              v-model="marcarTodos"
              autocomplete="off"
            />
            <label class="btn btn-avaliacao" for="checkboxTodos"
              >Marcar Todos</label
            >
          </div>
          <div class="d-flex flex-wrap gap-2 align-items-center">
            <div
              v-for="item in lista_empresas"
              :key="'emp_' + item.id"
              class="filter-item-single-line"
            >
              <input
                type="checkbox"
                :id="'emp_' + item.id"
                :value="item.id"
                v-model="selectedEmpresas"
                @click.stop
                class="filter-checkbox"
              />
              <label :for="'emp_' + item.id" class="filter-label">
                <span class="filter-icon"><i class="bi bi-building"></i></span>
                <span class="filter-text">{{ item.nome }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- KPIs Section -->
    <div class="row g-3 mb-4">
      <!-- KPI 1: Total de Avaliações -->
      <div class="col-md-3">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="bg-primary bg-opacity-10 rounded-3 p-3">
                <i class="bi bi-clipboard-data fs-1 text-primary"></i>
              </div>
              <div class="text-end">
                <div class="text-muted small text-uppercase">
                  Total Avaliações
                </div>
                <div class="fs-2 fw-bold">{{ totalAvaliacoes }}</div>
              </div>
            </div>
            <div class="progress" style="height: 4px">
              <div
                class="progress-bar bg-primary"
                role="progressbar"
                style="width: 100%"
              ></div>
            </div>
            <div class="mt-2 text-muted small">
              <i class="bi-check-circle-fill text-success p-1"></i>Finalizadas -
              {{ totalFinalizadas }}
              <i class="bi-x-circle-fill text-warning p-1"></i>Perdidas -
              {{ totalPerdidas }} <i class="bi-percent text-info p-1"></i> Taxa
              Conversão - {{ taxaConversao }}
            </div>
          </div>
        </div>
      </div>

      <!-- KPI 2: Total com Placa -->
      <div class="col-md-3">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="bg-success bg-opacity-10 rounded-3 p-3">
                <i class="bi bi-credit-card-2-front fs-1 text-success"></i>
              </div>
              <div class="text-end">
                <div class="text-muted small text-uppercase">Com Placa</div>
                <div class="fs-2 fw-bold">{{ avaliacoesComPlaca }}</div>
                <div class="text-muted small">{{ percentualComPlaca }}%</div>
              </div>
            </div>
            <div class="progress" style="height: 4px">
              <div
                class="progress-bar bg-success"
                role="progressbar"
                :style="{ width: percentualComPlaca + '%' }"
              ></div>
            </div>
            <div class="mt-2 text-muted small">
              <i class="bi bi-check-circle"></i> Informaram a placa na recepção
            </div>
          </div>
        </div>
      </div>

      <!-- KPI 3: Total sem Placa -->
      <div class="col-md-3">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="bg-warning bg-opacity-10 rounded-3 p-3">
                <i class="bi bi-credit-card-2-back fs-1 text-warning"></i>
              </div>
              <div class="text-end">
                <div class="text-muted small text-uppercase">Sem Placa</div>
                <div class="fs-2 fw-bold">{{ avaliacoesSemPlaca }}</div>
                <div class="text-muted small">{{ percentualSemPlaca }}%</div>
              </div>
            </div>
            <div class="progress" style="height: 4px">
              <div
                class="progress-bar bg-warning"
                role="progressbar"
                :style="{ width: percentualSemPlaca + '%' }"
              ></div>
            </div>
            <div class="mt-2 text-muted small">
              <i class="bi bi-exclamation-circle"></i> Não informaram a placa na
              recepção
            </div>
          </div>
        </div>
      </div>

      <!-- KPI 4: Valor Total Avaliado -->
      <div class="col-md-3">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="bg-info bg-opacity-10 rounded-3 p-3">
                <i class="bi bi-cash-stack fs-1 text-info"></i>
              </div>
              <div class="text-end">
                <div class="text-muted small text-uppercase">
                  Valor Total Concretizadas
                </div>
                <div class="fs-2 fw-bold">{{ valorTotalAvaliacoes }}</div>
                <div class="text-muted small">
                  Médio: {{ valorMedioAvaliacoes }}
                </div>
              </div>
            </div>
            <div class="progress" style="height: 4px">
              <div
                class="progress-bar bg-info"
                role="progressbar"
                style="width: 100%"
              ></div>
            </div>
            <div class="mt-2 text-muted small">
              <i class="bi bi-trending-up"></i> Soma de todos os valores
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Ranking de Vendedores -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card border-0 shadow-sm">
          <div class="card-header bg-white border-0 pt-4 pb-0">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h5 class="mb-1">
                  <i class="bi bi-trophy-fill text-warning"></i>
                  Ranking de Vendedores
                </h5>
                <p class="text-muted small mb-0">
                  Performance por quantidade de avaliações
                </p>
              </div>
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  :class="{ active: rankingType === 'quantidade' }"
                  @click="rankingType = 'quantidade'"
                >
                  <i class="bi bi-bar-chart"></i> Por Quantidade
                </button>
                <!-- <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  :class="{ active: rankingType === 'valor' }"
                  @click="rankingType = 'valor'"
                >
                  <i class="bi bi-cash-stack"></i> Por Valor
                </button> -->
              </div>
            </div>
          </div>
          <div class="card-body p-4">
            <div class="row">
              <!-- Tabela de Ranking -->
              <div class="col-lg-8">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead class="table-light">
                      <tr>
                        <th class="text-center" style="width: 60px">#</th>
                        <th>Vendedor</th>
                        <th
                          class="text-end"
                          v-if="rankingType === 'quantidade'"
                        >
                          <i class="bi bi-clipboard-check"></i> Qtd. Avaliações
                        </th>
                        <th class="text-end" v-if="rankingType === 'valor'">
                          <i class="bi bi-cash-stack"></i> Valor Total
                        </th>
                        <th class="text-end">Ticket Médio</th>
                        <th class="text-center" style="width: 100px">
                          % do Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(vendedor, index) in rankingVendedores"
                        :key="vendedor.id"
                      >
                        <td class="text-center align-middle">
                          <div v-if="index === 0" class="ranking-medal gold">
                            <i class="bi bi-trophy-fill"></i>
                          </div>
                          <div
                            v-else-if="index === 1"
                            class="ranking-medal silver"
                          >
                            <i class="bi bi-trophy-fill"></i>
                          </div>
                          <div
                            v-else-if="index === 2"
                            class="ranking-medal bronze"
                          >
                            <i class="bi bi-trophy-fill"></i>
                          </div>
                          <div v-else class="ranking-number">
                            {{ index + 1 }}
                          </div>
                        </td>
                        <td class="align-middle">
                          <div class="d-flex align-items-center">
                            <div
                              class="avatar-circle me-2"
                              :style="{
                                backgroundColor: getAvatarColor(vendedor.id),
                              }"
                            >
                              {{ vendedor.nome.charAt(0).toUpperCase() }}
                            </div>
                            <div>
                              <strong>{{ vendedor.nome }}</strong>
                              <div class="text-muted small">
                                ID: {{ vendedor.id }}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          class="text-end align-middle fw-bold"
                          v-if="rankingType === 'quantidade'"
                        >
                          {{ vendedor.quantidade }}
                        </td>
                        <td
                          class="text-end align-middle fw-bold"
                          v-if="rankingType === 'valor'"
                        >
                          {{ fmtBRL(vendedor.valorTotal) }}
                        </td>
                        <td class="text-end align-middle">
                          {{ fmtBRL(vendedor.ticketMedio) }}
                        </td>
                        <td class="align-middle">
                          <div class="d-flex align-items-center gap-2">
                            <div
                              class="progress flex-grow-1"
                              style="height: 6px"
                            >
                              <div
                                class="progress-bar"
                                :class="getProgressBarClass(index)"
                                role="progressbar"
                                :style="{ width: vendedor.percentual + '%' }"
                              ></div>
                            </div>
                            <span class="small text-muted"
                              >{{ vendedor.percentual }}%</span
                            >
                          </div>
                        </td>
                      </tr>
                      <tr v-if="rankingVendedores.length === 0">
                        <td colspan="5" class="text-center py-4 text-muted">
                          <i class="bi bi-inbox fs-3"></i>
                          <p class="mb-0">Nenhum vendedor encontrado</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Resumo do Top Vendedor -->
              <div class="col-lg-4" v-if="topVendedor">
                <div class="card bg-gradient-primary text-white h-100">
                  <div class="card-body text-center">
                    <div class="mb-3">
                      <div
                        class="avatar-circle-lg bg-white text-primary mx-auto mb-3"
                      >
                        {{ topVendedor.nome.charAt(0).toUpperCase() }}
                      </div>
                      <i class="bi bi-star-fill text-warning fs-5"></i>
                      <h4 class="mb-2">{{ topVendedor.nome }}</h4>
                      <p class="text-white-50 mb-3">Vendedor Destaque</p>
                    </div>
                    <div class="row">
                      <div class="col-6" v-if="rankingType === 'quantidade'">
                        <div class="border-bottom border-white-50 mb-2 pb-2">
                          <small class="text-white-50">Avaliações</small>
                          <h3 class="mb-0">{{ topVendedor.quantidade }}</h3>
                        </div>
                      </div>
                      <div class="col-6" v-if="rankingType === 'valor'">
                        <div class="border-bottom border-white-50 mb-2 pb-2">
                          <small class="text-white-50">Valor Total</small>
                          <h5 class="mb-0">
                            {{ fmtBRL(topVendedor.valorTotal) }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="border-bottom border-white-50 mb-2 pb-2">
                          <small class="text-white-50">Ticket Médio</small>
                          <h5 class="mb-0">
                            {{ fmtBRL(topVendedor.ticketMedio) }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-6">
                        <div>
                          <small class="text-white-50">Participação</small>
                          <h5 class="mb-0">{{ topVendedor.percentual }}%</h5>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3">
                      <i class="bi bi-arrow-up-circle"></i> Líder do ranking
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabela-->
    <div class="card card-tabela g-2 p-2">
      <div class="row g-2 p-2">
        <div class="card-title gy-4 linha">
          <i class="bi bi-graph-up-arrow icon-text-form"></i>
          <span class="txt-title-form">Relatório Avaliação</span>
        </div>

        <!-- Filtros e botões -->
        <div class="col-12 col-md-6 col-lg-4">
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              id="searchInput"
              v-model="searchTerm"
              placeholder="Pesquisar"
              @input="filterTable"
            />
            <label for="searchInput">
              <i class="bi bi-search"></i> Pesquisar em todos os campos...
            </label>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-8 d-flex justify-content-end gap-2">
          <div class="form-floating">
            <button class="btn round-btn" @click="exportToXLSX">
              <i class="bi bi-filetype-xlsx"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Tabela responsiva -->
      <div class="table-responsive" style="margin-top: 16px">
        <table
          id="tabela_conversao"
          class="table rf_texto_desk"
          ref="contentToPrint"
        >
          <thead>
            <tr>
              <th scope="col" class="rf_header_table">Loja</th>
              <th scope="col" class="rf_header_table">Data</th>
              <th scope="col" class="rf_header_table">Tipo</th>
              <th scope="col" class="rf_header_table">Cliente</th>
              <th scope="col" class="rf_header_table">Modelo</th>
              <th scope="col" class="rf_header_table">Valor avaliado</th>
              <th scope="col" class="rf_header_table">Valor quitação</th>
              <th scope="col" class="rf_header_table">Atendimento</th>
              <th scope="col" class="rf_header_table">Atendente</th>
              <th scope="col" class="rf_header_table">Vendedor</th>
              <th scope="col" class="rf_header_table">Gerente</th>
              <th scope="col" class="rf_header_table">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in filteredAvaliacoes"
              :key="item.id"
              class="table-linha"
            >
              <td class="rf_header_table">
                {{ item.empresa_proposta.nome ?? "-" }}
              </td>
              <td class="rf_header_table">
                {{ formattedDate(item.updatedAt) ?? "-" }}
              </td>
              <td class="rf_header_table">{{ item.status_proposta ?? "-" }}</td>
              <td class="rf_header_table">{{ item.clientes?.nome ?? "-" }}</td>
              <td class="rf_header_table">
                {{
                  item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao
                    .modelo ?? "-"
                }}
              </td>
              <td class="rf_header_table">
                {{
                  fmtBRL(
                    item.proposta_avaliacao_veiculo[0]?.precoAvaliacao,
                  ) ?? "-"
                }}
              </td>
              <td class="rf_header_table">
                {{
                  fmtBRL(item.proposta_avaliacao_veiculo[0]?.quitacao) ?? "-"
                }}
              </td>
              <td class="rf_header_table">{{ item.id ?? "-" }}</td>
              <td class="rf_header_table">
                {{ item.usuarios?.username ?? "-" }}
              </td>
              <td class="rf_header_table">
                {{ item.proposta_vendedores?.username ?? "-" }}
              </td>
              <td class="rf_header_table">
                {{ item.gerente_alteracao?.username ?? "-" }}
              </td>
              <td class="rf_header_table">
                <button
                  class="btn btn-sm btn-avaliacao"
                  @click="openModal(item)"
                >
                  <i class="bi bi-eye"></i> Visualizar
                </button>
              </td>
            </tr>
            <tr v-if="filteredAvaliacoes.length === 0">
              <td colspan="11" class="text-center py-4">
                <i class="bi bi-inbox"></i> Nenhum registro encontrado
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-overlay" v-if="showModal" @click="closeModal">
      <div class="modal-container powerbi-modal" @click.stop>
        <!-- Header com gradiente e ícone -->
        <div class="powerbi-modal-header">
          <div class="d-flex align-items-center gap-2">
            <div class="powerbi-icon-wrapper">
              <i class="bi bi-bar-chart-steps"></i>
            </div>
            <div>
              <h5 class="powerbi-modal-title">Detalhes da Avaliação</h5>
              <p class="powerbi-modal-subtitle">
                Relatório completo da transação
              </p>
            </div>
          </div>
          <button type="button" class="powerbi-close-btn" @click="closeModal">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="modal-body powerbi-modal-body" v-if="selectedItem">
          <!-- KPI Cards - Métricas principais -->
          <div class="powerbi-kpi-grid">
            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-cash-stack"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Valor Avaliado</div>
                <div class="kpi-value">
                  {{
                    currency(
                      selectedItem.proposta_avaliacao_veiculo[0]
                        ?.precoAvaliacao,
                    ) ?? "-"
                  }}
                </div>
                <div class="kpi-label">quit.: {{

                    currency(
                      selectedItem.proposta_avaliacao_veiculo[0]
                        ?.quitacao,
                    ) ?? "-"
                  }}</div>
              </div>
            </div>

            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-hash"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Atendimento Nº</div>
                <div class="kpi-value">{{ selectedItem.id ?? "-" }}</div>
              </div>
            </div>

            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-car-front"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Veículo</div>
                <div class="kpi-value">
                  {{
                    selectedItem.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao.modelo?.substring(
                      0,
                      20,
                    ) ?? "-"
                  }}
                </div>
              </div>
            </div>

            <div class="powerbi-kpi-card">
              <div
                class="kpi-icon"
                :class="getStatusClass(selectedItem.status_proposta)"
              >
                <i class="bi bi-circle-fill"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Status</div>
                <div
                  class="kpi-value"
                  :class="getStatusClass(selectedItem.status_proposta)"
                >
                  {{ selectedItem.status_proposta ?? "-" }}
                </div>
              </div>
            </div>
          </div>

          <!-- Seção Informações da Avaliação -->
          <div class="powerbi-section">
            <div class="powerbi-section-header">
              <i class="bi bi-building"></i>
              <h6>Informações da Avaliação</h6>
              <div class="section-line"></div>
            </div>
            <div class="powerbi-info-grid">
              <div class="powerbi-info-item">
                <div class="info-label">Loja</div>
                <div class="info-value">
                  {{ selectedItem.empresa_proposta.nome ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">Data</div>
                <div class="info-value">
                  {{ formattedDate(selectedItem.updatedAt) ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">Tipo</div>
                <div class="info-value">
                  {{ selectedItem.status_proposta ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">Cliente</div>
                <div class="info-value">
                  {{ selectedItem.clientes?.nome ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">Atendente</div>
                <div class="info-value">
                  {{ selectedItem.usuarios?.username ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">Vendedor</div>
                <div class="info-value">
                  {{ selectedItem.proposta_vendedores?.username ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">Gerente</div>
                <div class="info-value">
                  {{ selectedItem.gerente_alteracao?.username ?? "-" }}
                </div>
              </div>
            </div>
          </div>

          <!-- Seção Informações do Veículo -->
          <div class="powerbi-section">
            <div class="powerbi-section-header">
              <i class="bi bi-car-front"></i>
              <h6>Informações do Veículo Avaliado</h6>
              <div class="section-line"></div>
            </div>

            <!-- Destaque do veículo -->
            <div class="powerbi-vehicle-highlight">
              <div class="vehicle-main-info">
                <div class="vehicle-icon">
                  <i class="bi bi-truck"></i>
                </div>
                <div class="vehicle-details">
                  <div class="vehicle-title">
                    {{
                      selectedItem.proposta_avaliacao_veiculo[0]
                        ?.veiculo_usado_avaliacao.marca ?? "-"
                    }}
                    {{
                      selectedItem.proposta_avaliacao_veiculo[0]
                        ?.veiculo_usado_avaliacao.modelo ?? "-"
                    }}
                  </div>
                  <div class="vehicle-subtitle">
                    {{
                      selectedItem.proposta_avaliacao_veiculo[0]
                        ?.veiculo_usado_avaliacao.cor ?? "-"
                    }}
                    |
                    {{
                      selectedItem.proposta_avaliacao_veiculo[0]
                        ?.veiculo_usado_avaliacao.anoModelo ?? "-"
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div class="powerbi-info-grid">
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-arrow-left-right"></i> Veículo Troca na recepção
                </div>
                <div class="info-value">
                  {{ selectedItem.avaliacao == 1 ? 'Sim' : selectedItem.avaliacao == 0 ? 'Não' : '-' }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-card-text"></i> Infomado Placa na recepção
                </div>
                <div class="info-value">

                 {{ !selectedItem.placa_avaliacao ? 'Não' : 'Sim' }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label"><i class="bi bi-tag"></i> Marca</div>
                <div class="info-value">
                  {{
                    selectedItem.proposta_avaliacao_veiculo[0]
                      ?.veiculo_usado_avaliacao.marca ?? "-"
                  }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-car-front"></i> Modelo
                </div>
                <div class="info-value">
                  {{
                    selectedItem.proposta_avaliacao_veiculo[0]
                      ?.veiculo_usado_avaliacao.modelo ?? "-"
                  }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label"><i class="bi bi-palette"></i> Cor</div>
                <div class="info-value">
                  {{
                    selectedItem.proposta_avaliacao_veiculo[0]
                      ?.veiculo_usado_avaliacao.cor ?? "-"
                  }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label"><i class="bi bi-calendar"></i> Ano</div>
                <div class="info-value">
                  {{
                    selectedItem.proposta_avaliacao_veiculo[0]
                      ?.veiculo_usado_avaliacao.anoModelo ?? "-"
                  }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-credit-card"></i> Placa
                </div>
                <div class="info-value info-placa">
                  {{
                    selectedItem.proposta_avaliacao_veiculo[0]
                      ?.veiculo_usado_avaliacao.placa ?? "-"
                  }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-speedometer2"></i> Quilometragem
                </div>
                <div class="info-value">
                  {{
                    formatInt(
                      selectedItem.proposta_avaliacao_veiculo[0]?.kilometragem,
                    ) ?? "-"
                  }}
                  km
                </div>
              </div>
            </div>
          </div>

          <!-- Observações -->
          <div class="powerbi-section" v-if="selectedItem.observacoes">
            <div class="powerbi-section-header">
              <i class="bi bi-chat-text"></i>
              <h6>Observações</h6>
              <div class="section-line"></div>
            </div>
            <div class="powerbi-observations">
              <i class="bi bi-quote"></i>
              <p>{{ selectedItem.observacoes }}</p>
            </div>
          </div>
        </div>

        <div class="powerbi-modal-footer">
          <button
            type="button"
            class="powerbi-btn-secondary"
            @click="closeModal"
          >
            <i class="bi bi-x-circle"></i> Fechar
          </button>

        </div>
      </div>
    </div>
  </div>
  <RodapeVue />
</div>

</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import axios from "axios";
import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";
import XLSX from "xlsx/dist/xlsx.full.min";
import RodapeVue from "../../components/menu/Rodape.vue";
import NavgatorDk from "../../components/menu/NavgatorDk.vue";

export default {
  components: {
    SidebarVue,
    NavgatorDk,
    RodapeVue,
  },
  data() {
    return {
      avaliacoes_finalizadas: [],
      searchTerm: "",
      selectedItem: null,
      modal: null,
      total_atendimentos: "",
      selectedFilter: "hoje",
      startDate: "",
      endDate: "",
      user_id: "",
      company_id: "",
      lista_empresas: [],
      selectedEmpresas: [],
      marcarTodos: true,
      referencia: "",
      selectedRelatorio: "all",
      showModal: false,
      rankingType: "quantidade",
    };
  },
  computed: {
    filteredAvaliacoes() {
      if (!this.searchTerm) {
        return this.avaliacoes_finalizadas;
      }

      const searchLower = this.searchTerm.toLowerCase();

      return this.avaliacoes_finalizadas.filter((item) => {
        // Criar um objeto com todos os campos que serão pesquisados
        const searchableFields = {
          loja: item.empresa_proposta?.nome || "",
          data: this.formattedDate(item.updatedAt) || "",
          tipo: item.status_proposta || "",
          cliente: item.clientes?.nome || "",
          modelo:
            item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao
              .modelo || "",
          valor_avaliado:
            this.currency(item.proposta_avaliacao_veiculo[0]?.precoAvaliacao) ||
            "",
          proposta: item.id || "",
          atendente: item.usuarios?.username || "",
          vendedor: item.proposta_vendedores?.username || "",
          gerente: item.gerente_alteracao?.username || "",
          // Campos adicionais para pesquisa
          marca:
            item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao.marca ||
            "",
          cor:
            item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao.cor ||
            "",
          ano:
            item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao
              .anoModelo || "",
          placa:
            item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao.placa ||
            "",
          quilometragem:
            this.formatInt(item.proposta_avaliacao_veiculo[0]?.kilometragem) ||
            "",
          veiculo_troca: item.avaliacao || "",
          info_placa: item.placa_avaliacao || "",
        };

        // Verificar se algum campo contém o termo de busca
        return Object.values(searchableFields).some((value) =>
          String(value).toLowerCase().includes(searchLower),
        );
      });
    },

    totalAvaliacoes() {
      return this.avaliacoes_finalizadas?.length || 0;
    },

    totalFinalizadas() {
      const vendasFinalizadas = this.avaliacoes_finalizadas.filter(
        (item) => item.status_proposta === "Venda Finalizada",
      );
      return vendasFinalizadas?.length || 0;
    },

    totalPerdidas() {
      const vendasPerdidas = this.avaliacoes_finalizadas.filter(
        (item) => item.status_proposta === "Venda Perdida",
      );
      return vendasPerdidas?.length || 0;
    },

    taxaConversao() {
      const total = this.avaliacoes_finalizadas?.length || 0;
      const vendasFinalizadas = this.avaliacoes_finalizadas.filter(
        (item) => item.status_proposta === "Venda Finalizada",
      );
      const finalizadas = vendasFinalizadas?.length || 0;
      return total > 0 ? ((finalizadas / total) * 100).toFixed(2) : 0;
    },
    // Avaliações que informaram placa
    avaliacoesComPlaca() {
      if (!this.avaliacoes_finalizadas) return 0;
      return this.avaliacoes_finalizadas.filter(
        (item) => item.placa_avaliacao && item.placa_avaliacao.trim() !== "",
      ).length;
    },

    // Avaliações que NÃO informaram placa
    avaliacoesSemPlaca() {
      return this.totalAvaliacoes - this.avaliacoesComPlaca;
    },

    // Percentual com placa
    percentualComPlaca() {
      if (this.totalAvaliacoes === 0) return 0;
      return ((this.avaliacoesComPlaca / this.totalAvaliacoes) * 100).toFixed(
        1,
      );
    },

    // Percentual sem placa
    percentualSemPlaca() {
      if (this.totalAvaliacoes === 0) return 0;
      return ((this.avaliacoesSemPlaca / this.totalAvaliacoes) * 100).toFixed(
        1,
      );
    },

    // Soma total dos valores avaliados
    valorTotalAvaliacoes() {
      if (!this.avaliacoes_finalizadas) return "R$ 0,00";

      // Filtrar apenas vendas finalizadas
      const vendasFinalizadas = this.avaliacoes_finalizadas.filter(
        (item) => item.status_proposta === "Venda Finalizada",
      );

      const total = vendasFinalizadas.reduce((sum, item) => {
        const valor = item.proposta_avaliacao_veiculo[0]?.precoAvaliacao || 0;
        return sum + valor;
      }, 0);

      return this.fmtBRL(total);
    },

    // Valor médio das avaliações
    valorMedioAvaliacoes() {
      if (this.totalAvaliacoes === 0) return "R$ 0,00";

      // Filtrar apenas vendas finalizadas
      const vendasFinalizadas = this.avaliacoes_finalizadas.filter(
        (item) => item.status_proposta === "Venda Finalizada",
      );

      if (vendasFinalizadas.length === 0) return "R$ 0,00";

      const total = vendasFinalizadas.reduce((sum, item) => {
        const valor = item.proposta_avaliacao_veiculo[0]?.precoAvaliacao || 0;
        return sum + valor;
      }, 0);

      const media = total / vendasFinalizadas.length;
      return this.fmtBRL(media);
    },
    // Ranking de vendedores
    rankingVendedores() {
      if (!this.avaliacoes_finalizadas) return [];

      // Agrupar por vendedor
      const vendedoresMap = new Map();
      const vendasFinalizadas = this.avaliacoes_finalizadas.filter(
        (item) => item.status_proposta === "Venda Finalizada",
      );

      vendasFinalizadas.forEach((avaliacao) => {
        const vendedor = avaliacao.proposta_vendedores;
        if (!vendedor) return;

        const valor =
          avaliacao.proposta_avaliacao_veiculo[0]?.precoAvaliacao || 0;

        if (!vendedoresMap.has(vendedor.id)) {
          vendedoresMap.set(vendedor.id, {
            id: vendedor.id,
            nome: vendedor.username,
            quantidade: 0,
            valorTotal: 0,
            ticketMedio: 0,
            percentual: 0,
          });
        }

        const vendedorData = vendedoresMap.get(vendedor.id);
        vendedorData.quantidade++;
        vendedorData.valorTotal += valor;
      });

      // Calcular ticket médio
      const vendedoresArray = Array.from(vendedoresMap.values()).map((v) => {
        v.ticketMedio = v.quantidade > 0 ? v.valorTotal / v.quantidade : 0;
        return v;
      });

      // Ordenar baseado no tipo de ranking
      const sorted = [...vendedoresArray].sort((a, b) => {
        if (this.rankingType === "quantidade") {
          return b.quantidade - a.quantidade;
        } else {
          return b.valorTotal - a.valorTotal;
        }
      });

      // Calcular percentual baseado no tipo
      const total =
        this.rankingType === "quantidade"
          ? sorted.reduce((sum, v) => sum + v.quantidade, 0)
          : sorted.reduce((sum, v) => sum + v.valorTotal, 0);

      sorted.forEach((v) => {
        v.percentual =
          total > 0
            ? parseFloat(((v[this.rankingType] / total) * 100).toFixed(1))
            : 0;
      });

      return sorted;
    },

    // Top vendedor
    topVendedor() {
      return this.rankingVendedores[0] || null;
    },
  },
  mounted() {
    this.getToken();
    this.getEmpresas();

    //this.propostas_mes()
  },
  watch: {
    marcarTodos(newVal) {
      if (newVal) {
        this.selectedEmpresas = this.lista_empresas.map((item) => item.id);
      } else {
        this.selectedEmpresas = [];
      }
    },
    selectedEmpresas(newVal) {
      if (this.marcarTodos && newVal.length !== this.lista_empresas.length) {
        this.marcarTodos = false;
      }
    },
    lista_empresas: {
      handler(newList) {
        this.selectedEmpresas = newList.map((item) => item.id);
        this.selectedTipoVeiculo = [0, 1];
        // this.propostas_mes();
      },
      immediate: true, // Para executar a função ao criar o componente
    },
  },
  methods: {
    fmtBRL(n) {
      const value = Number(n || 0);
      const formatCompact = (val, suffix) => {
        const num = val.toFixed(2);
        // remove .00 quando não precisa
        const clean = num.endsWith(".00") ? num.slice(0, -3) : num;
        return `R$ ${clean}${suffix}`;
      };

      if (value >= 1000000000) return formatCompact(value / 1000000000, "B");
      if (value >= 1000000) return formatCompact(value / 1000000, "M");
      if (value >= 1000) return formatCompact(value / 1000, "K");

      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getAvatarColor(id) {
      const colors = [
        "#4361ee",
        "#3a0ca3",
        "#4cc9f0",
        "#f72585",
        "#b5179e",
        "#7209b7",
        "#560bad",
        "#4895ef",
        "#4d908e",
        "#f9844a",
      ];
      return colors[id % colors.length];
    },

    getProgressBarClass(index) {
      if (index === 0) return "bg-warning";
      if (index === 1) return "bg-secondary";
      if (index === 2) return "bg-info";
      return "bg-primary";
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    openModal(item) {
      this.selectedItem = item;
      this.showModal = true;
      console.log("Dados do item", item)
    },

    closeModal() {
      this.showModal = false;
      this.selectedItem = null;
    },

    // exportToXLSX() {
    //   const table = document.getElementById("tabela_conversao");
    //   const rows = table.querySelectorAll("tr");
    //   const data = [];

    //   rows.forEach((row) => {
    //     const rowData = [];
    //     const cells = row.querySelectorAll("td, th");
    //     cells.forEach((cell) => {
    //       rowData.push(cell.innerText);
    //     });
    //     data.push(rowData);
    //   });

    //   const ws = XLSX.utils.aoa_to_sheet(data);
    //   const wb = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(wb, ws, "Dados");
    //   XLSX.writeFile(wb, "avaliacoes_finalizadas.xlsx");
    // },
    exportToXLSX() {
      // Mapear os dados do array para as colunas desejadas
      const exportData = this.avaliacoes_finalizadas.map((item) => {
        return {
          Loja: item.empresa_proposta?.nome ?? "-",
          Data: this.formattedDate(item.updatedAt) ?? "-",
          Tipo: item.status_proposta ?? "-",
          Cliente: item.clientes?.nome ?? "-",
          "Veículo Troca": item.avaliacao ?? "-",
          "Info Placa": item.placa_avaliacao ?? "-",
          Marca:
            item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao.marca ??
            "-",
          Modelo:
            item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao
              .modelo ?? "-",
          Cor:
            item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao.cor ??
            "-",
          Ano:
            item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao
              .anoModelo ?? "-",
          Placa:
            item.proposta_avaliacao_veiculo[0]?.veiculo_usado_avaliacao.placa ??
            "-",
          Quilometragem:
            this.formatInt(item.proposta_avaliacao_veiculo[0]?.kilometragem) ??
            "-",
          "Valor Avaliado":
            this.currency(item.proposta_avaliacao_veiculo[0]?.precoAvaliacao) ??
            "-",
          Proposta: item.id ?? "-",
          Atendente: item.usuarios?.username ?? "-",
          Vendedor: item.proposta_vendedores?.username ?? "-",
          Gerente: item.gerente_alteracao?.username ?? "-",
        };
      });

      // Criar a planilha
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Avaliações Finalizadas");

      // Ajustar largura das colunas (opcional)
      const maxWidth = 20;
      ws["!cols"] = Object.keys(exportData[0] || {}).map(() => ({
        wch: maxWidth,
      }));

      // Exportar arquivo
      XLSX.writeFile(
        wb,
        `avaliacoes_finalizadas_${new Date().toISOString().slice(0, 10)}.xlsx`,
      );
    },
    getToken() {
      const accessToken = TokenService.getLocalAccessToken();

      // Obter o token de atualização (refresh token)
      TokenService.getLocalRefreshToken();

      // Obter o usuário completo (incluindo os tokens) se necessário
      TokenService.getUser();

      const decodedToken = jwt_decode(accessToken);
      console.log(decodedToken);
      this.company_id = decodedToken.company;
      this.user_id = decodedToken.id;
    },
    getRequestParams(
      EmpresasSelecionadas,
      page,
      pageSize,
      empresa_id,
      usuario_id,
      data_ini,
      data_fim,
      tipo_veiculo,
      tipo_conversao,
      referencia,
      selectedRelatorio,
    ) {
      let params = {};
      if (EmpresasSelecionadas) {
        params["ids"] = EmpresasSelecionadas;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      if (usuario_id) {
        params["usuario_id"] = usuario_id;
      }
      if (data_ini) {
        params["data_ini"] = data_ini;
      }
      if (data_fim) {
        params["data_fim"] = data_fim;
      }
      if (tipo_veiculo) {
        params["tipo_veiculo"] = tipo_veiculo;
      }
      if (tipo_conversao) {
        params["tipo_conversao"] = tipo_conversao;
      }
      if (referencia) {
        params["referencia"] = referencia;
      }
      if (selectedRelatorio) {
        params["selectedRelatorio"] = selectedRelatorio;
      }
      return params;
    },

    filtarRelatorios() {
      if (this.selectedFilter === "hoje") {
        this.referencia = this.selectedFilter;
      } else if (this.selectedFilter === "ontem") {
        this.referencia = this.selectedFilter;
      } else if (this.selectedFilter === "mes_atual") {
        this.referencia = this.selectedFilter;
      } else if (this.selectedFilter === "mes_anterior") {
        this.referencia = this.selectedFilter;
      }
    },
    async relatorio_avaliacoes_finalizadas() {
      console.log("Avaliações finalizadas");

      const params = this.getRequestParams(
        this.selectedEmpresas,
        this.page,
        this.pageSize,
        this.company_id,
        this.user_id,
        this.startDate,
        this.endDate,
        this.selectedTipoVeiculo,
        this.selectedTipoConversao,
        this.selectedFilter,
        this.selectedRelatorio,
      );

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}relatorio_avaliacoes_finalizadas`,
          {
            params,
          },
        );
        console.log("Relatorio Desk", response.data.rows);

        this.avaliacoes_finalizadas = response.data.rows;

        console.log(this.avaliacoes_finalizadas);
      } catch (error) {
        console.log(error);
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    async getEmpresas() {
      console.log("Buscando Empresas");
      const user_id = this.user_id;
      await axios
        .get(`${process.env.VUE_APP_API_URL}user_empresas`, {
          params: { id: user_id },
        })
        .then((response) => {
          this.lista_empresas = response.data;
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        });
    },

    currency(num) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(num);
    },
    formatInt(num) {
      return String(num)?.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") || "-";
    },
    formattedDate(item) {
      const date = new Date(item);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    getStatusClass(status) {
      const statusMap = {
        APROVADA: "status-approved",
        PENDENTE: "status-pending",
        REPROVADA: "status-rejected",
      };
      return statusMap[status] || "";
    },
  },
};
</script>
<style scoped>
/* Ranking Medals */
.ranking-medal {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin: 0 auto;
}

.ranking-medal.gold {
  background: linear-gradient(135deg, #ffd700, #ffb347);
  color: white;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
}

.ranking-medal.silver {
  background: linear-gradient(135deg, #c0c0c0, #a0a0a0);
  color: white;
  box-shadow: 0 2px 8px rgba(192, 192, 192, 0.3);
}

.ranking-medal.bronze {
  background: linear-gradient(135deg, #cd7f32, #b87333);
  color: white;
  box-shadow: 0 2px 8px rgba(205, 127, 50, 0.3);
}

.ranking-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #6c757d;
  margin: 0 auto;
}

/* Avatar Circle */
.avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 18px;
}

.avatar-circle-lg {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 32px;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.7);
}

.border-white-50 {
  border-color: rgba(255, 255, 255, 0.2) !important;
}
/* Estilo dos cards de KPI */
.card {
  border-radius: 12px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.bg-primary.bg-opacity-10 {
  background-color: rgba(13, 110, 253, 0.1);
}

.bg-success.bg-opacity-10 {
  background-color: rgba(25, 135, 84, 0.1);
}

.bg-warning.bg-opacity-10 {
  background-color: rgba(255, 193, 7, 0.1);
}

.bg-info.bg-opacity-10 {
  background-color: rgba(13, 202, 240, 0.1);
}

.progress {
  background-color: #e9ecef;
  border-radius: 2px;
}

.progress-bar {
  border-radius: 2px;
}
/* Power BI Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.2s ease;
}

.powerbi-modal {
  background: #ffffff;
  border-radius: 12px;
  max-width: 1000px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

/* Header Power BI */
.powerbi-modal-header {
  background: linear-gradient(135deg, #1e2a3a 0%, #0f172a 100%);
  color: white;
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.powerbi-icon-wrapper {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.powerbi-modal-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.3px;
}

.powerbi-modal-subtitle {
  font-size: 13px;
  opacity: 0.7;
  margin: 4px 0 0 0;
}

.powerbi-close-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  color: white;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.powerbi-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

/* Body */
.powerbi-modal-body {
  padding: 32px;
  background: #f8f9fc;
}

/* KPI Cards Grid */
.powerbi-kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.powerbi-kpi-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e9ecef;
  transition: all 0.3s;
}

.powerbi-kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.kpi-icon {
  width: 52px;
  height: 52px;
  background: linear-gradient(135deg, #922020 0%, #6e1818 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.kpi-content {
  flex: 1;
}

.kpi-label {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 8px;
}

.kpi-value {
  font-size: 20px;
  font-weight: 700;
  color: #1e2a3a;
}

/* Sections */
.powerbi-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e9ecef;
}

.powerbi-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  position: relative;
}

.powerbi-section-header i {
  font-size: 20px;
  color: #922020;
}

.powerbi-section-header h6 {
  font-size: 16px;
  font-weight: 600;
  color: #1e2a3a;
  margin: 0;
}

.section-line {
  flex: 1;
  height: 2px;
  background: linear-gradient(90deg, #922020 0%, transparent 100%);
}

/* Info Grid */
.powerbi-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.powerbi-info-item {
  padding: 12px;
  background: #f8f9fc;
  border-radius: 8px;
  transition: all 0.2s;
}

.powerbi-info-item:hover {
  background: #f1f3f5;
  transform: translateX(4px);
}

.info-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label i {
  font-size: 12px;
}

.info-value {
  font-size: 15px;
  font-weight: 500;
  color: #1e2a3a;
  word-break: break-word;
}

.info-placa {
  font-family: monospace;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
}

/* Vehicle Highlight */
.powerbi-vehicle-highlight {
  background: linear-gradient(135deg, #f8f9fc 0%, #ffffff 100%);
  border-left: 4px solid #922020;
  padding: 20px;
  margin-bottom: 24px;
  border-radius: 8px;
}

.vehicle-main-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.vehicle-icon {
  width: 60px;
  height: 60px;
  background: #92202010;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #922020;
}

.vehicle-title {
  font-size: 18px;
  font-weight: 700;
  color: #1e2a3a;
  margin-bottom: 4px;
}

.vehicle-subtitle {
  font-size: 13px;
  color: #6c757d;
}

/* Observations */
.powerbi-observations {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.powerbi-observations i {
  font-size: 24px;
  color: #922020;
  opacity: 0.5;
}

.powerbi-observations p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #495057;
}

/* Footer */
.powerbi-modal-footer {
  padding: 20px 32px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: white;
}

.powerbi-btn-primary,
.powerbi-btn-secondary {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
}

.powerbi-btn-primary {
  background: linear-gradient(135deg, #922020 0%, #6e1818 100%);
  color: white;
}

.powerbi-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(146, 32, 32, 0.3);
}

.powerbi-btn-secondary {
  background: #f8f9fc;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.powerbi-btn-secondary:hover {
  background: #e9ecef;
  transform: translateY(-1px);
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Scrollbar personalizada */
.powerbi-modal::-webkit-scrollbar {
  width: 8px;
}

.powerbi-modal::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.powerbi-modal::-webkit-scrollbar-thumb {
  background: #922020;
  border-radius: 4px;
}

.powerbi-modal::-webkit-scrollbar-thumb:hover {
  background: #6e1818;
}

/* Responsive */
@media (max-width: 768px) {
  .powerbi-modal {
    width: 95%;
    max-height: 95vh;
  }

  .powerbi-modal-body {
    padding: 20px;
  }

  .powerbi-kpi-grid {
    grid-template-columns: 1fr;
  }

  .powerbi-info-grid {
    grid-template-columns: 1fr;
  }

  .vehicle-main-info {
    flex-direction: column;
    text-align: center;
  }
}
.status-approved {
  color: #28a745 !important;
}

.status-pending {
  color: #ffc107 !important;
}

.status-rejected {
  color: #dc3545 !important;
}
.btn-avaliacao {
  --bs-btn-color: #fff;
  --bs-btn-bg: #922020;
  --bs-btn-border-color: #6e1818;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6e1818;
  --bs-btn-hover-border-color: #4a1010;
  --bs-btn-focus-shadow-rgb: 146, 32, 32;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4a1010;
  --bs-btn-active-border-color: #3a0c0c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6e1818;
  --bs-btn-disabled-border-color: #4a1010;
}

.btn-check:checked + .btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check) + .btn:active {
  color: var(--bs-btn-active-color);
  background-color: #4a1010;
  border-color: #3a0c0c;
}
</style>
